import Axios from "../../src/helpers/axios";

export const getAllProductBrands = () => {
  return Axios.get("/api/ecommerce/v1/brands/products/all");
};
